'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _popupConstants = require('../../../../../components/popupPanel/popupConstants');

var _iconsPopupConstants = require('./iconsPopupConstants');

var POPUP = _interopRequireWildcard(_iconsPopupConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    mode: POPUP.ICON_POPUP_MODE_DEFAULT,
    modesMenu: Immutable.Map(),
    searchResults: Immutable.Map(),
    elementSearches: Immutable.Map()
});

var setPopupMode = function setPopupMode(state, action) {
    var updateState = state;
    if (action.id) {
        updateState = state.setIn(['elementSearches', action.id, action.mode], action.mode);
    }
    return updateState.set('mode', action.mode);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _popupConstants.POPUP_OPEN:
        case _popupConstants.POPUP_TOGGLE:
            if (action.popupId !== 'icon') return state;
            return state.set('mode', null);
        case POPUP.ICON_POPUP_MODE_SET:
            return setPopupMode(state, action);
        case POPUP.ICON_POPUP_SEARCH_SUBMIT:
            return state.setIn(['searchResults', action.query], null);
        case POPUP.ICON_POPUP_SEARCH_SUCCESS:
            return state.setIn(['searchResults', action.query], Immutable.fromJS(action.icons));
        case POPUP.ICON_POPUP_SEARCH_FAILURE:
            return state.setIn(['searchResults', action.query], Immutable.List());
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/iconsPopupReducer.js
// module id = 2236
// module chunks = 0